import React from 'react';
import { explisoftService, error as errorToast } from '@services';

export enum YoutubeConnectionStatus {
    CONNECTED = 'connected',
    DISCONNECTED = 'disconnected',
    UNKNOWNE = 'unknown',
}

export const useYoutube = () => {
    const [isConnected, setIsConnected] = React.useState<YoutubeConnectionStatus>(YoutubeConnectionStatus.UNKNOWNE);

    React.useEffect(() => {
        explisoftService.checkYoutubeConnection()
            .then((connected: boolean) => {
                setIsConnected(connected ? YoutubeConnectionStatus.CONNECTED : YoutubeConnectionStatus.DISCONNECTED);
            })
            .catch((err) => {
                setIsConnected(YoutubeConnectionStatus.UNKNOWNE);
                errorToast(err.message || 'Something went wrong');
            });
    }, []);

    const connect = React.useCallback(() => {
        explisoftService.connectYoutube()
            .then(({ redirectUrl }) => {
                window.location.assign(redirectUrl);
            })
            .catch((err) => {
                errorToast(err.message || 'Something went wrong');
            });
    }, []);

    const disconnect = React.useCallback(() => {
        // show confirmation dialog
        if (!window.confirm('Are you sure you want to disconnect your Youtube account?')) {
            return;
        }
        explisoftService.disconnectYoutube()
            .then(() => {
                setIsConnected(YoutubeConnectionStatus.DISCONNECTED);
            })
            .catch((err) => {
                setIsConnected(YoutubeConnectionStatus.UNKNOWNE);
                errorToast(err.message || 'Something went wrong');
            });
    }, []);

    return {
        isConnected,
        connect,
        disconnect,
    };
}